// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + ' movido.',
  accCommandKey: () => 'Comando',
  accControlKey: () => 'Fechar',
  accPositionAfter: () => 'após',
  accPositionBefore: () => 'antes',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Pressione e mantenha pressionadas as teclas ' +
    p['keyPressed'] +
    ' e shift; em seguida, use as teclas de seta para reordenar.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Informe uma data completa como esta: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Informe um mês e um ano, desta forma: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupo',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valor',
  checkboxSet_requiredMessageDetail: () => 'Obrigatório',
  checkbox_requiredMessageDetail: () => 'Obrigatório',
  close: () => 'Fechar',
  collection_noData: () => 'Nenhum dado a ser exibido.',
  collection_selectAllRows: () => 'Selecionar todas as linhas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Selecionar a linha ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Não classificável',
  collection_sortEnabled: () => 'Classificável',
  confirmation: () => 'Confirmação',
  datePicker_currentDate: () => 'Data atual',
  datePicker_goToToday: () => 'Ir para hoje',
  datePicker_label: () => 'Seletor de Data',
  datePicker_month: () => 'Mês',
  datePicker_months: () => 'Meses',
  datePicker_next: () => 'Próximo',
  datePicker_nextDecade: () => 'Próxima década',
  datePicker_nextMonth: () => 'Próximo mês',
  datePicker_prev: () => 'Anterior',
  datePicker_prevDecade: () => 'Década anterior',
  datePicker_prevMonth: () => 'Mês anterior',
  datePicker_restricted: () => 'Restrito',
  datePicker_selected: () => 'Selecionado',
  datePicker_today: () => 'Hoje',
  datePicker_weekNum: (p: { NUM: string }) => 'Semana ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Número de Semana',
  datePicker_year: () => 'Ano',
  datePicker_years: () => 'Anos',
  error: () => 'Erro',
  expandableList_expandCollapseInstructionText: () =>
    'Use as teclas de seta para expandir e contrair',
  expandableList_groupCollapse: () => 'Contraído',
  expandableList_groupExpand: () => 'Expandido',
  filePicker_addFiles: () => 'Adicionar Arquivos',
  filePicker_dropzonePrimaryText: () => 'Arrastar e Soltar',
  filePicker_dropzoneSecondaryText: () => 'Selecione um arquivo ou solte um aqui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecione ou solte arquivos aqui',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Não é possível fazer upload de arquivos do tipo ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Faz upload um arquivo por vez',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Não é possível fazer upload de arquivos do tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'desconhecido',
  formControl_clear: () => 'Limpar',
  formControl_day: () => 'Dia',
  formControl_helpAvailable: () => 'Ajuda disponível',
  formControl_hide: () => 'Ocultar',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Você atingiu o limite ' +
    ((
      {
        one: new Intl.NumberFormat('pt').format(p['CHARACTER_LIMIT']) + '-caractere',
        many: new Intl.NumberFormat('pt').format(p['CHARACTER_LIMIT']) + '-caractere'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('pt').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('pt').format(p['CHARACTER_LIMIT']) + '-caractere') +
    '.',
  formControl_loading: () => 'Carregando',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Você pode inserir até ' + p['MAX_LENGTH'] + ' caracteres.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caracteres restantes.',
  formControl_month: () => 'Mês',
  formControl_readOnly: () => 'Somente para leitura',
  formControl_requiredMessageDetail: () => 'Digite um valor.',
  formControl_show: () => 'Mostrar',
  formControl_year: () => 'Ano',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Fim',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Linha',
  gantt_labelStart: () => 'Início',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenhuma seção correspondente encontrada.',
  indexer_keyboardInstructionText: () => 'Pressione enter para selecionar um valor.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toque duas vezes e mantenha para entrar no modo de gestos. Em seguida, arraste para cima ou para baixo para ajustar o valor.',
  info: () => 'Informações',
  inputDateMask_date_cleared: () => 'Data apagada',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Vazio',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Informe uma data igual ou anterior a ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Informe uma data que seja posterior ou igual a ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Informe uma data disponível.',
  inputDatePicker_instruction: () => 'Pressione Tab para acessar o calendário.',
  inputDatePicker_selectDate: () => 'Selecionar uma data',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Informe um mês e um ano iguais ou anteriores a ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Informe um mês e um ano iguais ou posteriores a ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Informe um número.',
  inputNumber_decrease: () => 'Reduzir',
  inputNumber_increase: () => 'Aumentar',
  inputPassword_hidden: () => 'Senha Oculta',
  inputPassword_hide: () => 'Ocultar Senha',
  inputPassword_show: () => 'Mostrar Senha',
  inputSensitiveText_hidden: () => 'Texto confidencial oculto',
  list_msgFetchCompleted: () => 'Carregada',
  list_msgFetchingData: () => 'Carregando',
  list_suggestion: () => 'Sugestão',
  messageToast_allMessagesClosed: () =>
    'Todas as mensagens de notificação do sistema foram fechadas.',
  message_close: () => 'Fechar',
  message_confirmation: () => 'Sucesso',
  message_error: () => 'Erro',
  message_info: () => 'Informações',
  message_navigationFromMessagesRegion: () =>
    'Entrando na área de mensagens. Pressione F6 para navegar de volta ao elemento focado anteriormente.',
  message_navigationToMessagesRegion: () =>
    'A área de mensagens tem novas mensagens. Pressione F6 para navegar até a área de mensagens mais recentes.',
  message_warning: () => 'Advertência',
  noData_message: () => 'Não há itens para exibição',
  overflowItemLabel: () => 'Mais Guias',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Em Andamento',
  radio_helpForRadio: () => 'Ajuda para botão de opção',
  radio_requiredMessageDetail: () => 'Selecione um valor.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Voltar',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Use as teclas de seta para a esquerda e para a direita para destacar valores selecionados.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pressione Backspace or Delete para remover o valor selecionado.',
  selectMultiple_selectedValues: () => 'Valores selecionados',
  selectMultiple_showSelectedValues: () => 'Mostrar só os valores selecionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores selecionados.',
  select_addToList: () => 'Adicionar à lista',
  select_addToListAvailable: () => 'Adicionar à lista disponível',
  select_moreSearchOptions: () => 'Mais opções de pesquisa',
  select_moreSearchOptionsAvailable: () => 'Mais opções de pesquisa disponíveis',
  select_noMatchesFound: () => 'Nenhuma correspondência encontrada.',
  select_oneMatchFound: () => 'Uma correspondência encontrada',
  select_requiredMessageDetail: () => 'Selecione um valor.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondências encontradas',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' ou mais correspondências encontradas',
  selectorAll_deselectAll: () => 'Desmarcar tudo',
  selectorAll_selectAll: () => 'Selecionar tudo',
  selector_selected: () => 'Caixa de seleção marcada',
  selector_unselected: () => 'Caixa de seleção não marcada',
  tabBarNavigationList_removeCueText: () => 'Removível',
  timeComponent_tooltipZoomIn: () => 'Mais Zoom',
  timeComponent_tooltipZoomOut: () => 'Menos Zoom',
  train_current: () => 'Atual',
  train_message_type: () => 'Tipo de Mensagem',
  train_not_visited: () => 'Não visitado',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etapa ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitado',
  userAssistance_learnMore: () => 'Saiba mais',
  userAssistance_required: () => 'Obrigatório',
  vis_clearSelection: () => 'Limpar Seleção',
  vis_drillable: () => 'Disponível para drill',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Seleção de retângulo de marcação',
  vis_marqueeZoomTooltip: () => 'Zoom de retângulo de marcação',
  vis_noData: () => 'Nenhum dado a ser exibido',
  vis_panTooltip: () => 'Panorama',
  vis_stateLoaded: () => 'Carregado',
  vis_stateLoading: () => 'Carregando',
  vis_stateSelected: () => 'Selecionado',
  vis_stateUnselected: () => 'Não Selecionado',
  warn: () => 'Advertência'
};
export default bundle;
